const normalizeTrends = (data: any): any => {
  return data.reduce((prev: any, current: any) => {
    if (current && Array.isArray(current) && current.length > 0) {
      const newArray = current.reduce(
        (arr: any, item: any) => arr.concat([item]),
        []
      );
      return prev.concat(newArray);
    }
    return prev;
  }, []);
};

export default normalizeTrends;
